(() => {
 const bar=document.querySelector('[data-shipping-bar]');
 if(!bar)return;
 const threshold=Math.max(0,Number(bar.dataset.threshold)||0);
 const currency=bar.dataset.currency||'EUR';
 const fmt=n=>new Intl.NumberFormat('es-ES',{style:'currency',currency}).format(n/100);
 const render=cart=>{
  const total=Number(cart.total_price)||0;
  bar.hidden=!(Number(cart.item_count)>0);
  const left=Math.max(0,threshold-total);
  const label=left===0?'¡Has conseguido el envío gratis!':`Te faltan ${fmt(left)} para el envío gratis`;
  bar.querySelector('.cp-shipping-label').textContent=label;
  bar.querySelector('.cp-shipping-fill').style.width=threshold?`${Math.min(100,Math.max(0,total/threshold*100))}%`:'0%';
  document.querySelectorAll('[data-shipping-message]').forEach(el=>el.textContent=label);
  document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count||0);
 };
 const refresh=()=>fetch((window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin'}).then(r=>r.json()).then(render).catch(()=>{});
 render({total_price:Number(bar.dataset.subtotal)||0,item_count:Number(document.querySelector('[data-cart-count]')?.textContent)||0});
 document.addEventListener('copipet:cart-updated',refresh);
 window.addEventListener('pageshow',refresh);
 document.addEventListener('submit',e=>{if(e.target.matches('form[action*="/cart/add"]'))setTimeout(refresh,900)},true);
 const originalFetch=window.fetch;
 window.fetch=function(...args){
  const url=String(args[0]?.url||args[0]||'');
  const p=originalFetch.apply(this,args);
  if(/\/cart\/(add|change|update|clear)\.js(?:\?|$)/.test(url))p.then(r=>{if(r.ok)setTimeout(refresh,80)}).catch(()=>{});
  return p;
 };
})();